export const filterModelStyle = {
    content: {
        top: "60%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        padding: '0px',
        height: "400px",
        marginRight: "-50%",
        overflow: 'scroll',
        backgroundColor: "#151535",
        transform: "translate(-50%, -50%)",
    },
};

export const graphModalStyle = {
    content: {
        top: "60%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        padding: '0px',
        marginRight: "-50%",
        overflow: 'scroll',
        backgroundColor: "#151535",
        transform: "translate(-50%, -50%)",
    },
};